export enum ScreenSize {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export enum Breakpoint {
  XS = '(max-width: 575.98px)',
  SM = '(min-width: 576px) and (max-width: 767.98px)',
  MD = '(min-width: 768px) and (max-width: 991.98px)',
  LG = '(min-width: 992px) and (max-width: 1199.98px)',
  XL = '(min-width: 1200px)',
}
